import { CIQError, Country, ErrorResponse } from "@arbolus-technologies/api";

export const GET_COUNTRIES = "CACHE_GET_COUNTRIES";
export const GET_COUNTRIES_SUCCESS = "CACHE_GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILURE = "CACHE_GET_COUNTRIES_FAILURE";

export interface GetCountriesAction {
  type: typeof GET_COUNTRIES;
}

export interface GetCountriesSuccessAction {
  type: typeof GET_COUNTRIES_SUCCESS;
  payload: {
    countries: Country[];
  };
}

export interface GetCountriesFailureAction {
  type: typeof GET_COUNTRIES_FAILURE;
  payload: {
    error: ErrorResponse<CIQError>;
  };
}
